import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CustomerService {
    apiUrl: string = environment.apiUrl;
    headers = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private httpClient: HttpClient) { }

    getAll() {
        return this.httpClient.get(`${this.apiUrl}customers`);
    }

    getById(id: number) {
        return this.httpClient.get(`${this.apiUrl}customers/${id}`);
    }

    getAudit(id: number) {
        return this.httpClient.get(`${this.apiUrl}customers/${id}/audit`);
    }

    getAllActive() {
        return this.httpClient.get(`${this.apiUrl}customers/active`);
    }

    updateStatusCustomerData(id: number, status: string) {
        const params = {
            status
        };

        return this.httpClient.patch(
            `${this.apiUrl}customers/${id}/status`,
            null,
            { params }
        );
    }

    saveCustomerData(customerData: any) {
        const formData = new FormData();

        formData.append(
            'data',
            new Blob([JSON.stringify(customerData)], { type: 'application/json' })
        );

        return this.httpClient.post(
            `${this.apiUrl}customers`,
            formData
        );
    }

    resetUserPassword(payload: { userId: number; newPassword: string }) {
        return this.httpClient.post(`${this.apiUrl}users/reset-password`, payload);
    }
}
